import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { selectIsOptionalById, updateAssetUrlByIds } from '../_redux';
import { AppDispatch, WebsiteState } from '@gift/website-state/store';
import { Card } from '@gift/ui/components/card/Card';
import { Grid } from '@gift/ui/components/grid/Grid';

export const _SvgInputRemoveSelection = ({
    variableIds, active, commit
}: Props) => {
    const { t } = useTranslation();
    return (
        <Card onClick={() => commit(variableIds)} active={active}>
            <Grid align='center' justify='center' className='idt-h-full'>
                {t('commons.none')}
            </Grid>
        </Card>
    );
};

type Props = {
    variableIds: string[],
    active?: boolean,
    commit: (variableId: string[]) => void
}

const mapStateToProps = (state: WebsiteState, ownProps: { variableIds: string[] }) => ({
    isOptional: selectIsOptionalById(state, ownProps.variableIds[0])!
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    commit: (variableIds: string[]) => dispatch(updateAssetUrlByIds(variableIds, null))
});

export const SvgInputRemoveSelection = connect(
    mapStateToProps,
    mapDispatchToProps
)(_SvgInputRemoveSelection);
